const limitLength = (value, limit) => (value && value.slice(0, limit));

export { limitLength };



// WEBPACK FOOTER //
// ./src/utils/formValidations.js